import { render, staticRenderFns } from "./BookingDetailShorex.vue?vue&type=template&id=70a9c0d0&scoped=true"
import script from "./BookingDetailShorex.vue?vue&type=script&lang=js"
export * from "./BookingDetailShorex.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailShorex.vue?vue&type=style&index=0&id=70a9c0d0&prod&lang=less&scoped=true"
import style1 from "./BookingDetailShorex.vue?vue&type=style&index=1&id=70a9c0d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9c0d0",
  null
  
)

export default component.exports